<div class="flex min-h-screen items-center justify-center bg-[#031b33] px-4 text-white">
  <div class="w-full max-w-md text-center">
    <div
      class="mx-auto mb-6 flex h-20 w-20 items-center justify-center rounded-full border-4 border-[#fc6e52] bg-[#fc6e52]/10"
    >
      <span class="text-4xl font-bold text-[#fc6e52]">!</span>
    </div>

    <h1 class="mb-3 text-4xl font-extrabold text-[#fc6e52]">Unauthorized</h1>

    <p class="mb-6 text-white/80"
      >You don’t have access to view this page. If you believe this is an error, please contact your administrator.</p
    >

    <a
      class="inline-block font-semibold text-[#fc6e52] underline underline-offset-4 transition-all duration-200 hover:text-white hover:underline-offset-8"
      routerLink="/login"
      >← Return to Login</a
    >
  </div>
</div>
